
import { ComponentController } from '@r-core';
import { IslandConnectionSymbol, type SvgActionMenuConfig } from '@r-components';

type Metadata = {
	controller: ComponentController;
	panelId: string;
};

export const islandConnectionMenuConfig = (metadata: Metadata): SvgActionMenuConfig => {
	return {
		key: metadata.panelId,
		icon: (props: React.SVGProps<SVGCircleElement>) => <IslandConnectionSymbol {...props}/>,
		menuOptions: {
			menuButtonRadius: 3
		},
		items: [
			{
				label: 'Pd',
				tooltip: 'Connection Properties',
				confirm: true,
				handler: () => {
					metadata.controller.publishShowProperties('connection', metadata.panelId);
				}
			}
		]
	};
};
